import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "trigger"]

  connect() {
    // Close dropdown when clicking outside
    this.clickOutsideHandler = this.clickOutside.bind(this)
    document.addEventListener("click", this.clickOutsideHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.menuTarget.classList.remove("hidden")
    // Add active state to trigger (dark transparent container per design)
    if (this.hasTriggerTarget) {
      this.triggerTarget.classList.add("dropdown-trigger-active")
    }
  }

  hide() {
    this.menuTarget.classList.add("hidden")
    // Remove active state from trigger
    if (this.hasTriggerTarget) {
      this.triggerTarget.classList.remove("dropdown-trigger-active")
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}